import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../api";
import { WindowInfo } from "../types/window";

const initialState: WindowInfo = {
    stepCurrent: "main",
    loaderWindow: true,
    loaderButton: false,
    checkoutMsg: "",
    globalMsg: "",
    headerCutsom: "",
    isTestMode: false,
    animationDirection: "forward",
    serverUnavailable: false,
    routeStack: [
        {
            path: "",
            step: "main",
            swipe: "forward",
        },
    ],
    paymentStep: {
        type: "",
        token: "",
        public_key: "",
    },
    token: "",
    projectId: "",
    savedCards: [],
    availablePaymentMethods: [],
    isSecondaryMenu: false,
    availablePlans: [],
    mySubscriptions: {
        active: [],
        inactive: [],
    },
    planByLinkInformation: null,
    selectedMySubscription: null,
    isSelectedPlanTrial: false,
    selectedPlan: null,
    saluteCounter: 0,
    AuthorizationType: {
        account: {
            id: "",
            telegram_account_id: "",
            created_at: null,
            public_key: "",
        },
        token: null,
    },
    myProjects: [],
    selectedProject: null,
    dashboard: null,
    selectedStatisticType: "",
    statisticItems: null,
    selectedStatisticItem: null,
    myGroupsAndPlans: [],
    projectResources: null,
    products: [],
    selectedProducts: {
        selected_product_items: [],
        total: [],
        next_total: [],
        next_charge_date: "",
    },
    statisticPage: [],
    prognosisPayments: [],
};

const windowInfo = createSlice({
    name: "window",
    initialState,
    reducers: {
        setIsSecondaryMenu(state, action: PayloadAction<boolean>) {
            state.isSecondaryMenu = action.payload;
        },
        changeStep(state, action: PayloadAction<string>) {
            state.stepCurrent = action.payload;
        },
        setAnimationDirection(state, action: PayloadAction<string>) {
            state.animationDirection = action.payload;
        },
        isMainLoader(state, action: PayloadAction<boolean>) {
            state.loaderWindow = action.payload;
        },
        isButtonLoader(state, action: PayloadAction<boolean>) {
            state.loaderButton = action.payload;
        },
        setCheckoutMsg(state, action: PayloadAction<string>) {
            state.checkoutMsg = action.payload;
        },
        setGlobalMsg(state, action: PayloadAction<string>) {
            state.globalMsg = action.payload;
        },
        pushRoute(state, action) {
            state.routeStack.push(action.payload);
            state.animationDirection = "forward";
        },
        popRoute(state, action: PayloadAction<number | null>) {
            const count = action.payload ?? 1;
            for (let i = 0; i < count; i++) {
                if (state.routeStack.length > 0) {
                    state.routeStack.pop();
                } else {
                    break;
                }
            }
            state.animationDirection = "backward";
        },
        resetRouteStack(state) {
            state.routeStack = [];
        },
        setProjectId(state, action: PayloadAction<string>) {
            state.projectId = action.payload;
        },
        navigateToPage(state, action: PayloadAction<string>) {
            state.stepCurrent = action.payload;
            state.animationDirection = "forward";
            state.routeStack.push({
                step: action.payload,
                path: action.payload,
                swipe: "forward",
            });
        },
        setSelectedMySubscription(state, action: PayloadAction<any>) {
            state.selectedMySubscription = action.payload;
        },
        setSelectedAvailablePlan(state, action: PayloadAction<any>) {
            state.selectedPlan = action.payload;
        },
        setTrialMode(state, action: PayloadAction<boolean>) {
            state.isSelectedPlanTrial = action.payload;
        },
        needSalute(state) {
            state.saluteCounter++;
        },
        setSelectedStatisticType(state, action: PayloadAction<string>) {
            state.selectedStatisticType = action.payload;
        },
        setSelectedStatisticItem(state, action: PayloadAction<any>) {
            state.selectedStatisticItem = action.payload;
        },
        increase(state, { payload }) {
            if (
                state.selectedProducts.selected_product_items.find(
                    (item) => item.product_item_id === payload.id
                )
            ) {
                state.selectedProducts.selected_product_items = state.selectedProducts.selected_product_items.map((item) => {
                    if (item.product_item_id === payload.id) {
                        return {
                            ...item,
                            count: item.count + 1,
                        };
                    }
                    return item;
                });
            } else {
                state.selectedProducts.selected_product_items.push({
                    product_item_id: payload.id,
                    count: 1,
                });
            }
        },
        decrease(state, { payload }) {
            state.selectedProducts.selected_product_items = state.selectedProducts.selected_product_items.map((item) => {
                if (item.product_item_id === payload.id) {
                    const newCount = item.count - 1;
                    
                        return {
                            ...item,
                            count: newCount,
                        };
                    
                }
                return item;
            }).filter(item => item.count > 0);
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                api.endpoints.getBepaidToken.matchFulfilled,
                (state, { payload }) => {
                    state.paymentStep = payload;
                    state.stepCurrent = payload.type;
                    state.animationDirection = "backward";
                    state.routeStack.push({
                        step: payload.type,
                        path: payload.type,
                        swipe: "forward",
                    });
                }
            )
            .addMatcher(
                api.endpoints.getBepaidToken.matchRejected,
                (state, action) => {
                    // console.log(action);
                    // if (payload.status === 500) {
                    state.globalMsg =
                        "Произошла ошибка. Попробуйте чуть позже.";
                    // }
                }
            )
            .addMatcher(
                api.endpoints.login.matchFulfilled,
                (state, { payload }) => {
                    state.token = payload.token;
                    state.AuthorizationType.account = payload.account;
                }
            )
            .addMatcher(
                api.endpoints.register.matchFulfilled,
                (state, { payload }) => {
                    state.token = payload.token;
                }
            )
            .addMatcher(
                api.endpoints.register.matchRejected,
                (state, action) => {
                    state.globalMsg =
                        "Произошла ошибка при авторизации. Попробуйте чуть позже.";
                }
            )
            .addMatcher(
                api.endpoints.getSavedCards.matchFulfilled,
                (state, { payload }) => {
                    state.savedCards = payload;
                }
            )
            .addMatcher(
                api.endpoints.deleteSavedCard.matchFulfilled,
                (state, { payload }) => {
                    state.savedCards = payload;
                }
            )
            .addMatcher(
                api.endpoints.getPaymentMethods.matchFulfilled,
                (state, { payload }) => {
                    state.availablePaymentMethods = payload;
                }
            )
            .addMatcher(
                api.endpoints.getPaymentMethods.matchRejected,
                (state, action) => {
                    // console.log(action);
                }
            )
            .addMatcher(
                api.endpoints.getMyProjects.matchFulfilled,
                (state, { payload }) => {
                    state.myProjects = payload;
                    state.projectId = payload[0].id;
                }
            )

            .addMatcher(
                api.endpoints.getStatistics.matchFulfilled,
                (state, { payload }) => {
                    state.dashboard = payload;
                }
            )

            .addMatcher(
                api.endpoints.getStatisticsCategory.matchFulfilled,
                (state, { payload }) => {
                    state.statisticItems = payload;
                }
            )

            .addMatcher(
                api.endpoints.getMySubscriptions.matchFulfilled,
                (state, { payload }) => {
                    state.mySubscriptions = payload;
                }
            )

            .addMatcher(
                api.endpoints.getProjectGroupsAndPlans.matchFulfilled,
                (state, { payload }) => {
                    state.myGroupsAndPlans = payload;
                }
            )

            .addMatcher(
                api.endpoints.getProjectTariff.matchFulfilled,
                (state, { payload }) => {
                    state.projectResources = payload;
                }
            )

            .addMatcher(
                api.endpoints.getProducts.matchFulfilled,
                (state, { payload }) => {
                    state.products = payload;
                }
            )
            .addMatcher(
                api.endpoints.getStatisticByPlan.matchFulfilled,
                (state, { payload }) => {
                    state.statisticPage = payload;
                }
            )
            .addMatcher(
                api.endpoints.tariffAddProducts.matchFulfilled,
                (state, { payload }) => {
                    state.selectedProducts = payload;
                }
            )
            .addMatcher(
                api.endpoints.prognosisPayments.matchFulfilled,
                (state, { payload }) => {
                    state.prognosisPayments = payload;
                }
            );
    },
});

export const {
    changeStep,
    isMainLoader,
    isButtonLoader,
    setCheckoutMsg,
    setGlobalMsg,
    setAnimationDirection,
    pushRoute,
    popRoute,
    resetRouteStack,
    setProjectId,
    navigateToPage,
    setIsSecondaryMenu,
    setSelectedMySubscription,
    setSelectedAvailablePlan,
    setTrialMode,
    needSalute,
    setSelectedStatisticType,
    setSelectedStatisticItem,
    increase,
    decrease
} = windowInfo.actions;
export default windowInfo.reducer;
